import React from "react";
import { cn } from "@/lib/utils";

function PageHeader({ children, className }) {
  return (
    <div className={cn("flex items-center justify-between flex-wrap gap-3", className)}>
      {children}
    </div>
  );
}

function Title({ children, eyebrow, className }) {
  return (
    <div className={className}>
      {eyebrow && (
        <div className="text-xs uppercase tracking-[0.18em] text-muted-foreground">{eyebrow}</div>
      )}
      <h1 className="font-display text-3xl font-bold tracking-tight mt-1">{children}</h1>
    </div>
  );
}

function Actions({ children, className }) {
  return (
    <div className={cn("flex items-center gap-2", className)}>
      {children}
    </div>
  );
}

PageHeader.Title = Title;
PageHeader.Actions = Actions;

export default PageHeader;
